module.exports = __webpack_public_path__ + "static/media/Immobilier-Transformation-Vaud.92883fa1.jpg";